import * as React from "react";
const SvgVisibilityVisible20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M2.686 10.476A14.49 14.49 0 0 1 2.393 10a15.316 15.316 0 0 1 1.904-2.572C5.72 5.888 7.66 4.5 10 4.5c2.34 0 4.28 1.387 5.703 2.928A15.31 15.31 0 0 1 17.607 10a15.314 15.314 0 0 1-1.904 2.572C14.28 14.112 12.34 15.5 10 15.5c-2.34 0-4.28-1.387-5.703-2.928a15.32 15.32 0 0 1-1.611-2.096Zm16.958-.924L18.75 10c.895.447.894.447.894.448l-.001.003-.003.006-.01.018a6.214 6.214 0 0 1-.158.293 17.307 17.307 0 0 1-2.3 3.16C15.595 15.638 13.16 17.5 10 17.5s-5.595-1.863-7.172-3.572a17.314 17.314 0 0 1-2.3-3.16 10.615 10.615 0 0 1-.158-.293l-.01-.018-.003-.006v-.002l-.001-.001L1.25 10l-.894-.448.001-.003.003-.006.01-.019a6.457 6.457 0 0 1 .158-.292 17.315 17.315 0 0 1 2.3-3.16C4.405 4.362 6.84 2.5 10 2.5s5.595 1.863 7.172 3.572a17.308 17.308 0 0 1 2.3 3.16 10.83 10.83 0 0 1 .158.292l.01.02.003.005v.002l.001.001ZM18.75 10l.895-.447.223.447-.223.447L18.75 10ZM.356 9.553 1.25 10l-.894.447L.132 10l.224-.447ZM9 10a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z",
      clipRule: "evenodd"
    })
  );
export default SvgVisibilityVisible20Px;
